import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutColumnDirective } from './layout-column.directive';


@NgModule({
    declarations: [LayoutColumnDirective],
    imports: [
        CommonModule
    ],
    exports: [
        LayoutColumnDirective
    ]
})
export class LayoutColumnModule {}
